import React from 'react';
import { Phone, Plus, Trash2 } from 'lucide-react';

const TelecomServicesSection = ({ 
  services, 
  onServiceChange, 
  onAddService, 
  onRemoveService 
}) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between border-b pb-2">
        <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
          <Phone className="w-5 h-5 text-blue-600" />
          Telecommunications Services
        </h2>
        <button
          type="button"
          onClick={onAddService}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
        >
          <Plus className="w-4 h-4" />
          Add Service
        </button>
      </div>

      {services.map((service, index) => (
        <div
          key={service.id}
          className="bg-gray-50 rounded-lg p-6 space-y-4"
        >
          <div className="flex items-center justify-between">
            <h3 className="font-medium text-gray-800">
              Service {index + 1}
            </h3>
            {services.length > 1 && (
              <button
                type="button"
                onClick={() => onRemoveService(index)}
                className="text-red-600 hover:text-red-700 p-1"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            )}
          </div>

          {/* Description as simple text field */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Description
            </label>
            <input
              type="text"
              value={service.description}
              onChange={(e) => onServiceChange(index, "description", e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Enter service description"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Service Type - Simplified with fixed options */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Service Type
              </label>
              <select
                value={service.service_type}
                onChange={(e) => onServiceChange(index, "service_type", e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">Select Service Type</option>
                <option value="SIP">SIP</option>
                <option value="ISDN">ISDN</option>
                <option value="ANALOG">Analog</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Existing Tel No
              </label>
              <input
                type="text"
                value={service.existing_tel_no}
                onChange={(e) =>
                  onServiceChange(
                    index,
                    "existing_tel_no",
                    e.target.value
                  )
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Current telephone number"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Quantity (No. of lines)
              </label>
              <input
                type="number"
                value={service.quantity}
                onChange={(e) =>
                  onServiceChange(
                    index,
                    "quantity",
                    e.target.value
                  )
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Number of lines"
                min="0"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Postcode (if required)
              </label>
              <input
                type="text"
                value={service.postcode}
                onChange={(e) =>
                  onServiceChange(
                    index,
                    "postcode",
                    e.target.value
                  )
                }
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Postcode of homeworker"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TelecomServicesSection;